import { jsx } from "react/jsx-runtime";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import { validateTidalLicense } from "../../base/index.js";
function DirectionsCarOutlined(props) {
  return /* @__PURE__ */ jsx(
    DirectionsCarOutlinedIcon,
    {
      "data-testid": "DirectionsCarOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "DirectionsCarOutlined",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
DirectionsCarOutlined.tidalIconMeta = {
  categories: "miscellaneous",
  name: "DirectionsCarOutlined"
};
validateTidalLicense();
export {
  DirectionsCarOutlined
};
//# sourceMappingURL=DirectionsCarOutlined.js.map
